import { render, staticRenderFns } from "./typeOfResources.vue?vue&type=template&id=2758324e&"
import script from "./typeOfResources.vue?vue&type=script&lang=js&"
export * from "./typeOfResources.vue?vue&type=script&lang=js&"
import style0 from "./typeOfResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports